import { Box, FormGroup, Grid, IconButton, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { useTableScroll } from './utils';
import { SmartImage } from 'components/account/jobs/image-slider/smart-image';
import './template-labels.css';
const LargeTableCell = styled(TableCell)({
    fontSize: '1.3rem'
});
export const TemplateLabelsForm = ({ drawRectangleMode, editWord, listPoints, newWord, onAddNewWord, overwriteRectangle, photoDimensions, photoUrl, setDrawRectangleMode, setEditWord, setListPoints, setNewWord, layout }) => {
    const [currentPointIndex, setCurrentPointIndex] = useState(null);
    const [currentRowIndex, setCurrentRowIndex] = useState();
    const handleListPointWeightChange = (index, e) => {
        const val = Number.parseFloat(e.target.value);
        const newPoints = [...listPoints];
        newPoints[index].weight = val;
        setListPoints(newPoints);
    };
    const hasBadWhitespaces = newWord !== newWord.trim();
    const tableBodyRef = useTableScroll(currentPointIndex, layout === 'row');
    const handleRowMouseExit = useCallback(() => {
        setCurrentRowIndex(undefined);
    }, []);
    return (React.createElement(Grid, { container: true, direction: layout, spacing: 2, wrap: "nowrap" },
        React.createElement(Grid, { item: true },
            React.createElement(SmartImage, { className: layout === 'row' ? 'sticky-image' : '', editIndex: editWord, highlightIndex: currentRowIndex, image: {
                    dimensions: photoDimensions,
                    url: photoUrl
                }, listPoints: listPoints.map((point, idx) => point.points.map((pointPoints) => ({
                    ...pointPoints,
                    widx: idx
                }))), maxHeightPerc: 0.7, noPoints: false, onMouseOutPoint: (pts) => {
                    if (pts.length) {
                        setCurrentPointIndex(null);
                    }
                }, onMouseOverPoint: (pts) => {
                    if (pts.length) {
                        setCurrentPointIndex(pts[0].widx);
                    }
                }, readonly: !drawRectangleMode, twoPointClick: true, updatePoints: overwriteRectangle })),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { marginBottom: 6 },
                React.createElement(FormGroup, null,
                    React.createElement(TextField, { InputProps: {
                            endAdornment: (React.createElement(IconButton, { className: "fa fa-plus fa-solid", disabled: newWord === '', onClick: onAddNewWord, title: "Add new word" }))
                        }, className: "g-full-width u-margin-bottom-small", error: hasBadWhitespaces, helperText: hasBadWhitespaces ? 'Leading or trailing whitespaces.' : '', label: "New Word", onChange: (e) => {
                            setNewWord(e.target.value);
                        }, style: { marginBottom: '24px' }, value: newWord }))),
            React.createElement(Table, { padding: "none", size: "medium", stickyHeader: true, style: {
                    fontSize: '2rem'
                } },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(LargeTableCell, null, "Word"),
                        React.createElement(LargeTableCell, null, "Weight"),
                        React.createElement(LargeTableCell, { align: "right" }, "Actions"))),
                React.createElement(TableBody, { ref: tableBodyRef }, listPoints.map((listPoint, pointIndex) => {
                    const widx = pointIndex;
                    return (React.createElement(TableRow, { className: `template-cell ${currentPointIndex === widx ? 'highlight' : null}`, 
                        // eslint-disable-next-line react/no-array-index-key
                        key: pointIndex, onMouseEnter: () => {
                            setCurrentRowIndex(pointIndex);
                        }, onMouseLeave: handleRowMouseExit },
                        React.createElement(LargeTableCell, { style: { fontSize: '1.5rem' } }, listPoint.word),
                        React.createElement(LargeTableCell, null,
                            React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", inputProps: {
                                    type: 'number',
                                    step: 0.01
                                }, onChange: (e) => {
                                    handleListPointWeightChange(widx, e);
                                }, value: listPoint.weight })),
                        React.createElement(LargeTableCell, { align: "right" },
                            React.createElement(IconButton, { className: "fa fa-solid fa-trash", onClick: () => {
                                    const newPoints = listPoints.filter((_val, idx) => {
                                        return idx !== widx;
                                    });
                                    setListPoints(newPoints);
                                }, title: "Delete" }),
                            ' ',
                            React.createElement(IconButton, { className: `fa fa-solid fa-crop-alt ${editWord !== null && editWord === widx ? 'on' : ''}`, onClick: () => {
                                    if (widx === editWord) {
                                        setEditWord(null);
                                        setDrawRectangleMode(false);
                                    }
                                    else {
                                        setEditWord(widx);
                                        const newPoints = [...listPoints];
                                        newPoints[widx].points = [];
                                        setListPoints(newPoints);
                                        setDrawRectangleMode(true);
                                    }
                                }, title: "Select area" }),
                            ' ',
                            React.createElement(IconButton, { className: `fa fa-image ${listPoints[widx].image ? 'on' : ''}`, onClick: () => {
                                    const newPoints = [...listPoints];
                                    // TODO: Figure this out?
                                    newPoints[widx].image = !newPoints[widx].image;
                                    setListPoints(newPoints);
                                }, title: "Mark as image" }))));
                }))))));
};
